import { updatesData } from '@/mocks/home';

export default function SectionUpdates() {
  return (
    <section id="updates" className="py-12 md:py-16 px-4 md:px-6 bg-background-50" style={{ scrollMarginTop: '4rem' }}>
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading font-bold text-xl md:text-2xl lg:text-3xl text-foreground-950 mb-2">
            吃瓜快讯
          </h2>
          <p className="text-sm text-foreground-500">24小时滚动更新，不错过任何一条猛料</p>
        </div>
        <div className="relative pl-8 md:pl-10 border-l-2 border-background-200 ml-4">
          {updatesData.map((item, i) => (
            <div key={i} className={`relative mb-6 last:mb-0 ${i === 0 ? 'border-l-primary-500' : ''}`}>
              <div className={`absolute -left-[29px] md:-left-[33px] top-1 w-4 h-4 rounded-full border-2 ${
                i === 0 ? 'bg-primary-500 border-primary-500' : 'bg-background-50 border-background-300'
              }`}></div>
              <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3 mb-1">
                <span className="text-xs text-foreground-500 whitespace-nowrap">{item.time}</span>
                <span className={`inline-block px-2 py-0.5 rounded-md text-xs font-medium w-fit whitespace-nowrap ${
                  item.tag === '最新' || item.tag === '独家'
                    ? 'bg-primary-100 text-primary-700'
                    : item.tag === '热议' || item.tag === '争议'
                    ? 'bg-accent-100 text-accent-700'
                    : 'bg-secondary-100 text-secondary-700'
                }`}>{item.tag}</span>
              </div>
              <h3 className="text-sm md:text-base text-foreground-950 font-medium leading-snug cursor-pointer hover:text-primary-600 transition-colors">{item.title}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}